/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import Select from 'react-select'
import { makeAnimated } from 'react-select';

import { Frame, Text, convertHex, P, H1, H } from '../../UIKit/styled-templates'
import Input from '../../UIKit/Input'
import Button from '../../UIKit/Button'
import Form from '../../UIKit/Form'
import CommonHelper from '../../../helpers/CommonHelper';
import ProjectTab from '../tools/ProjectTab'

import useCurrentUser from '../helpers/useCurrentUser'
import useDictionary from '../helpers/useDictionary'

let ProjectsListPage = () => {

    let { currentUser } = useCurrentUser()
    let { getText } = useDictionary()

    return (
        <Wrapper>

            <H extra={`@media only screen and (max-width: 600px) { margin-top: 5vw; };`} >{getText(`Settings`)}</H>

            {/* <Form fields={[{ name: `Email`, type: `string` }]} editable={false} /> */}
            {/* <P>{currentUser.username || `Email`}</P> */}

            <H1 extra={`@media only screen and (max-width: 600px) { margin-top: 5vw; };`} >{getText(`change_password`)}</H1>

            <Form fields={[
                { name: `Old password`, type: `password` },
                { name: `New password`, type: `password` },
                { name: `Confirm password`, type: `password` },
            ]} editable={true} />

            <Button extra={`width: 230px;`} >{getText(`Save`)}</Button>

        </Wrapper>
    );
}

let VerifiedSign = styled.img.attrs((props) => {
    let img
    try { img = require(`../../../assets/images/approved_company.svg`) } catch (error) { }
    return ({ src: img, })
})`
    width: 24px;
    height: 24px;
    margin-left: 3px;
`

const Tab = styled(Frame)`
    width: 535px;
    height: 300px;
    border-radius: 12px;
    margin-top: 30px;
    justify-content: space-between;
    cursor: pointer;
    overflow: hidden;
    box-shadow: 6px 6px 24px rgba(0, 0, 0, 0.07);
    &:hover {
        box-shadow: 0px 20px 60px rgba(87, 138, 214, 0.2);
    }
`;

const Wrapper = styled(Frame)`
    // position: relative;
    width: 815px;
    align-items: flex-start;
    margin-left: 125px;

    @media only screen and (max-width: 600px) {
        width: 90vw;
        margin: 0;
    }
`;

const FilterToolsWrapper = styled(Frame)`
    width: 1100px;
    margin-top: 30px;
    flex-direction: row;
    justify-content: space-between;

    @media only screen and (max-width: 600px) {
        width: 90vw;
    }
`;

export default ProjectsListPage;

/*eslint-enable*/